

/** 
  All of the routes for the Material Dashboard 2 React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that has other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

// Material Dashboard 2 React layouts
import React from "react";
import Icon from "@mui/material/Icon";
import Leads from "layouts/crm/Leads";
import Accounts from "layouts/crm/Accounts";
import LeadDetail from "layouts/crm/LeadDetail";
import AccountDetail from "layouts/crm/AccountDetail";
import Customer360Route from "layouts/crm/Customer360Route";
import Settings from "layouts/crm/Settings";
import CustomModulePage from "layouts/crm/CustomModulePage";
// import UserManagement from "layouts/crm/UserManagement";
import EmailSetup from "layouts/crm/EmailSetup";
import Deals from "layouts/crm/Deals";
import AutomationBuilder from "layouts/crm/AutomationBuilder";
import DealDetail from "layouts/crm/DealDetail";
import Inventory from "layouts/crm/Inventory";
import ProductDetail from "layouts/crm/ProductDetail";
import Quotation from "layouts/crm/Quotation";
import QuotationDetail from "layouts/crm/QuotationDetail";
import Orders from "layouts/crm/Orders";
import OrderDetail from "layouts/crm/OrderDetail";
import Tasks from "layouts/tasks";
import Inbox from "layouts/inbox";
import AgentMap from "layouts/crm/AgentMap";
import Invoices from "layouts/crm/Invoices";
import Contacts from "layouts/crm/Contacts";
import ContactDetail from "layouts/crm/ContactDetails";
import GmailAuthCallback from "components/SettingsComponents/GmailCallback";
// import UserProfile from "layouts/crm/UserPage";
import SearchResults from "layouts/crm/SearchResults";
import CreatePasswordPage from "layouts/crm/CreatePaaword";
import Cases from "layouts/crm/Cases";
import CaseDetail from "layouts/crm/CaseDetail";
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import UserProfile from "layouts/profile/UserProfile";
import ViewUserProfile from "layouts/profile/ReadOnlyUserProfile";
import ResetPassword from "layouts/crm/PasswordReset";
// The reports module. Replaces the six hardcoded pages that used to live in
// layouts/crm — Reports, CustomReport, LeadReports, SalesPerformance,
// ProductPerformance, AccountEngagement and CaseReports — whose content came
// from nowhere the user could change. Their analytics are now seeded report
// templates, which can be run, edited, cloned and charted like any other.
import ReportsHome from "layouts/analytics/ReportsHome";
import ReportBuilder from "layouts/analytics/ReportBuilder";
import ReportViewer from "layouts/analytics/ReportViewer";
import DashboardsList from "layouts/analytics/DashboardsList";
import DashboardPage from "layouts/analytics/DashboardPage";
import HomeDashboard from "layouts/analytics/HomeDashboard";
import SupportTicket from "layouts/crm/SupportTicket";
import InvoiceDetail from "layouts/crm/InvoiceDetail";
import CMSPublishers from "layouts/crm/CMSPublishers";
import TripOptions from "layouts/crm/TripOptions";
import CMSPublisherDetail from "layouts/crm/CMSPublisherDetail";
import GuideAllocations from "layouts/crm/GuideAllocations";
import GuideAllocationDetail from "layouts/crm/GuideAllocationDetail";
import CreatorOnboardings from "layouts/crm/CreatorOnboardings";
import CreatorOnboardingDetail from "layouts/crm/CreatorOnboardingDetail";
import Creators from "layouts/crm/Creators";
import CreatorDetail from "layouts/crm/CreatorDetail";
import CustomObjectsList from "layouts/crm/CustomObjectsList";
import CustomObjectList from "layouts/crm/CustomObjectList";
import CustomObjectDetail from "layouts/crm/CustomObjectDetail";
import CustomObjectDesigner from "layouts/crm/CustomObjectDesigner";
import CustomObjectsSettingsPage from "layouts/crm/CustomObjectsSettingsPage";
import RolesPermissions from "layouts/crm/RolesPermissions";
import RoleDetail from "layouts/crm/RolesPermissions/RoleDetail";
import TeamsSettings from "layouts/crm/RolesPermissions/Teams";
import UserRecordV2 from "layouts/crm/users-v2/UserRecordV2";
import SkillsSettings from "layouts/crm/RolesPermissions/Skills";
import PaymentSettingsPage from "layouts/crm/PaymentSettingsPage";
import PaymentGatewaySetupPage from "layouts/crm/PaymentGatewaySetupPage";
import TelephonySettingsPage from "layouts/crm/TelephonySettingsPage";
import RealEstateSettingsPage from "layouts/RealEstate/settings/RealEstateSettingsPage";
import SeepAISettingsPage from "layouts/crm/SeepAISettingsPage";
import AiAssistantSettingsPage from "layouts/crm/AiAssistantSettingsPage";
import DeveloperSettingsPage from "layouts/crm/DeveloperSettingsPage";
import OAuthConsent from "layouts/oauth/Consent";
import ConnectedApps from "layouts/oauth/ConnectedApps";
import SeepLogo from "components/SeepLogo";
import TwilioSetupPage from "layouts/crm/TwilioSetupPage";
import TelephonyNumbersPage from "layouts/crm/TelephonyNumbersPage";
import TelephonyRoutingPage from "layouts/crm/TelephonyRoutingPage";
import TelephonyRecordingPage from "layouts/crm/TelephonyRecordingPage";
import TelephonyIvrPage from "layouts/crm/TelephonyIvrPage";
import QueuesSettingsPage from "layouts/crm/QueuesSettingsPage";
import QueueCapacityPage from "layouts/crm/QueueCapacityPage";
import WorkQueuesPage from "layouts/crm/WorkQueuesPage";
import AgentWorkloadPage from "layouts/crm/AgentWorkloadPage";
import CallConsole from "layouts/callcenter/CallConsole";
import SupervisorConsole from "layouts/callcenter/SupervisorConsole";
import CallDetail from "layouts/callcenter/CallDetail";
import EmailToCaseSettingsPage from "layouts/crm/EmailToCaseSettingsPage";
import IntegrationsSettingsPage from "layouts/crm/IntegrationsSettingsPage";
import MessagesPage from "layouts/messages/MessagesPage";
import PaymentCheckoutPage from "layouts/Travel/orders/PaymentCheckoutPage";
import PublicPayPage from "layouts/public/PublicPayPage";
import MerchantAllocationRespond from "layouts/public/MerchantAllocationRespond";
import MerchantOrderLineRespond from "layouts/public/MerchantOrderLineRespond";
import TripOptionDetail from "layouts/crm/TripOptionDetail";
import TripSubOptions from "layouts/crm/TripSubOptions";
import TripSubOptionDetail from "layouts/crm/TripSubOptionDetail";
import DepartureDates from "layouts/crm/DepartureDates";
import DepartureDateDetail from "layouts/crm/DepartureDateDetail";
import Addons from "layouts/crm/Addons";
import AddonDetail from "layouts/crm/AddonDetail";
import FAQs from "layouts/crm/FAQs";
import FAQDetail from "layouts/crm/FAQDetail";
import Itineraries from "layouts/crm/Itineraries";
import ItineraryDetail from "layouts/crm/ItineraryDetail";
import ItineraryDays from "layouts/crm/ItineraryDays";
import ItineraryDayDetail from "layouts/crm/ItineraryDayDetail";
import ItineraryDayLineItems from "layouts/crm/ItineraryDayLineItems";
import ItineraryDayLineItemDetail from "layouts/crm/ItineraryDayLineItemDetail";
import DayLineItems from "layouts/crm/DayLineItems";
import DayLineItemDetail from "layouts/crm/DayLineItemDetail";
import TripComponents from "layouts/crm/TripComponents";
import TripComponentDetail from "layouts/crm/TripComponentDetail";
import MerchantAssets from "layouts/crm/MerchantAssets";
import MerchantAssetDetail from "layouts/crm/MerchantAssetDetail";
import TrainingModules from "layouts/crm/TrainingModules";
import TrainingModuleDetail from "layouts/crm/TrainingModuleDetail";
import TrainingCompletions from "layouts/crm/TrainingCompletions";
import TrainingCompletionDetail from "layouts/crm/TrainingCompletionDetail";
import PaymentTerms from "layouts/crm/PaymentTerms";
import PaymentTermDetail from "layouts/crm/PaymentTermDetail";
import MerchantAssetInventories from "layouts/crm/MerchantAssetInventories";
import MerchantAssetInventoryDetail from "layouts/crm/MerchantAssetInventoryDetail";
import MerchantAllocations from "layouts/crm/MerchantAllocations";
import MerchantAllocationDetail from "layouts/crm/MerchantAllocationDetail";
import TravelOrderDetailView from "layouts/Travel/orders/TravelOrderDetailView";
import Insurances from "layouts/crm/Insurances";
import InsuranceDetail from "layouts/crm/InsuranceDetail";
import TravelOrderItems from "layouts/crm/TravelOrderItems";
import TravelOrderItemDetail from "layouts/crm/TravelOrderItemDetail";
import TravelOrderPax from "layouts/crm/TravelOrderPax";
import TravelOrderPaxDetail from "layouts/crm/TravelOrderPaxDetail";
import TravelOrderItemPax from "layouts/crm/TravelOrderItemPax";
import TravelOrderItemPaxDetail from "layouts/crm/TravelOrderItemPaxDetail";
import OrderItineraries from "layouts/crm/OrderItineraries";
import TravelInvoices from "layouts/crm/TravelInvoices";
import TravelInvoiceDetail from "layouts/crm/TravelInvoiceDetail";
import GuideTripNotes from "layouts/crm/GuideTripNotes";
import GuideTripNoteDetail from "layouts/crm/GuideTripNoteDetail";
import ReferralCodes from "layouts/crm/ReferralCodes";
import ReferralCodeDetail from "layouts/crm/ReferralCodeDetail";
import TravelInvoiceLineItems from "layouts/crm/TravelInvoiceLineItems";
import TravelInvoiceLineItemDetail from "layouts/crm/TravelInvoiceLineItemDetail";
import OrderItineraryDetail from "layouts/crm/OrderItineraryDetail";
import MerchantOrderLines from "layouts/crm/MerchantOrderLines";
import MerchantOrderLineDetail from "layouts/crm/MerchantOrderLineDetail";
import OrderCoupons from "layouts/crm/OrderCoupons";
import OrderCouponDetail from "layouts/crm/OrderCouponDetail";
import OrderComms from "layouts/crm/OrderComms";
import OrderCommDetail from "layouts/crm/OrderCommDetail";
import Coupons from "layouts/crm/Coupons";
import CouponDetail from "layouts/crm/CouponDetail";
import PaymentTransactions from "layouts/Travel/payment-transactions/PaymentTransactions";
import PaymentTransactionDetail from "layouts/Travel/payment-transactions/PaymentTransactionDetail";
import OrderCancellations from "layouts/crm/OrderCancellations";
import OrderCancellationDetail from "layouts/crm/OrderCancellationDetail";
import Merchants from "layouts/crm/Merchants";
import MerchantDetail from "layouts/crm/MerchantDetail";
import TravelContacts from "layouts/crm/TravelContacts";
import TravelContactDetail from "layouts/crm/TravelContactDetail";
import Opportunities from "layouts/crm/Opportunities";
import OpportunityDetail from "layouts/crm/OpportunityDetail";
import Customers from "layouts/crm/Customers";
import CustomerDetail from "layouts/crm/CustomerDetail";
import PricingCategories from "layouts/crm/PricingCategories";
import PricingCategoryDetail from "layouts/crm/PricingCategoryDetail";
import CustomerCoupons from "layouts/crm/CustomerCoupons";
import CustomerCouponDetail from "layouts/crm/CustomerCouponDetail";
import LoyaltyRules from "layouts/crm/LoyaltyRules";
import LoyaltyRuleDetail from "layouts/crm/LoyaltyRuleDetail";
import LoyaltyLedgers from "layouts/crm/LoyaltyLedgers";
import LoyaltyLedgerDetail from "layouts/crm/LoyaltyLedgerDetail";
import LoyaltySummaries from "layouts/crm/LoyaltySummaries";
import LoyaltySummaryDetail from "layouts/crm/LoyaltySummaryDetail";
import LoyaltyTiers from "layouts/crm/LoyaltyTiers";
import LoyaltyTierDetail from "layouts/crm/LoyaltyTierDetail";
import ReferralRedemptions from "layouts/crm/ReferralRedemptions";
import ReferralRedemptionDetail from "layouts/crm/ReferralRedemptionDetail";
import ReferralProgramSettings from "layouts/crm/ReferralProgramSettings";
import ReferralProgramSettingDetail from "layouts/crm/ReferralProgramSettingDetail";
import GuideOnboardings from "layouts/crm/GuideOnboardings";
import GuideOnboardingDetail from "layouts/crm/GuideOnboardingDetail";
import ContactLookup from "layouts/crm/ContactLookup";
// Travel
import Trips from "layouts/Travel/trips/Trips";
import TripPackages from "layouts/Travel/trips/TripPackages";
import CreateTripLegacy from "layouts/Travel/trips/CreateTrip"; // untouched fallback
import TripPackageDetail from "layouts/Travel/trips/TripPackageDetail"; // untouched fallback
import CreateTripV2 from "layouts/Travel/trips/CreateTripV2"; // active modular wizard
import TripDetail from "layouts/Travel/trips/Tripdetail";
import PaymentTemplates from "layouts/Travel/payment-templates/PaymentTemplates";
import PaymentTemplateDetail from "layouts/Travel/payment-templates/PaymentTemplateDetail";
import HSS from "layouts/Travel/hss/HighSeasonSurcharge";
import HSSDetail from "layouts/Travel/hss/HighSeasonSurchargeDetail";
import TripEntityList from "layouts/Travel/trip-entities/TripEntityList";
import TripEntityDetail from "layouts/Travel/trip-entities/TripEntityDetail";
// Orders
import TravelOrders from "layouts/crm/TravelOrders";
import CreateTravelOrder from "layouts/Travel/orders/CreateTravelOrder";
// Orders
import CompanySettings from "layouts/company-settings/Companysettings"
import MerchantServiceRequestSettings from "layouts/Travel/settings/MerchantServiceRequestSettings"
import WebsiteSettingsPage from "layouts/crm/WebsiteSettingsPage";

// Real Estate edition. Hand-built screens live in layouts/RealEstate/screens;
// reference pages are config-driven (layouts/RealEstate/reEntityConfig.js).
import ReDashboard from "layouts/RealEstate/screens/ReDashboard";
import ReInventoryGrid from "layouts/RealEstate/screens/InventoryGrid";
import ReProjectDetail from "layouts/RealEstate/screens/ProjectDetail";
import ReBookingsList from "layouts/RealEstate/screens/BookingsList";
import ReBookingWizard from "layouts/RealEstate/screens/BookingWizard";
import ReBookingDetail from "layouts/RealEstate/screens/BookingDetail";
import RePaymentPlans from "layouts/RealEstate/screens/PaymentPlans";
import RePaymentPlanDetail from "layouts/RealEstate/screens/PaymentPlanDetail";
import ReViewingsCalendar from "layouts/RealEstate/screens/ViewingsCalendar";
import ReUnitHolds from "layouts/RealEstate/screens/UnitHolds";
import ReCommissionsLedger from "layouts/RealEstate/screens/CommissionsLedger";
import ReCommissionPayouts from "layouts/RealEstate/screens/CommissionPayouts";
import ReMarginReport from "layouts/RealEstate/screens/MarginReport";
import ReLeasesList from "layouts/RealEstate/screens/LeasesList";
import ReLeaseDetail from "layouts/RealEstate/screens/LeaseDetail";
import ReRentSchedule from "layouts/RealEstate/screens/RentSchedule";
import ReMortgagePipeline from "layouts/RealEstate/screens/MortgagePipeline";
import ReMortgageApplicationDetail from "layouts/RealEstate/screens/MortgageApplicationDetail";
import { ReEntityList, ReEntityDetail } from "layouts/RealEstate/ReEntityPages";
import { ByUi } from "layouts/RealEstate/v2/parts";
import ReHomeV2 from "layouts/RealEstate/v2/ReHomeV2";
import ListingsV2 from "layouts/RealEstate/v2/ListingsV2";
import ListingRecordV2 from "layouts/RealEstate/v2/ListingRecordV2";
import ApplicationsV2 from "layouts/RealEstate/v2/applications/ApplicationsV2";
import ApplicationRecordV2 from "layouts/RealEstate/v2/applications/ApplicationRecordV2";
import ReApplicationsClassicNotice from "layouts/RealEstate/v2/applications/ClassicNotice";

// Flip to true to instantly restore the original single-file wizard.
const USE_LEGACY_TRIP_WIZARD = false;
const CreateTrip = USE_LEGACY_TRIP_WIZARD ? CreateTripLegacy : CreateTripV2;

const routes = [

  { type: "title", title: "Sales", key: "title-pages2" },
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <HomeDashboard />,
  },
  {
    type: "collapse",
    name: "Contact Detail",
    key: "contact-detail",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/contacts/:id",
    component: <ContactDetail />
  },
  {
    type: "collapse",
    name: "Leads",
    key: "leads",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/leads",
    component: <Leads />,
  },
  {
    type: "collapse",
    name: "Accounts",
    key: "accounts",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/accounts",
    component: <Accounts />,
  },
  {
    type: "collapse",
    name: "Contacts",
    key: "contacts",
    icon: <Icon fontSize="small">people</Icon>,
    route: "/contacts",
    component: <Contacts />
  },
  {
    type: "collapse",
    name: "Custom Objects",
    key: "custom-objects",
    icon: <Icon fontSize="small">extension</Icon>,
    route: "/custom-objects",
    component: <CustomObjectsList />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "Custom Object Records",
    key: "custom-object-list",
    icon: <Icon fontSize="small">extension</Icon>,
    route: "/custom-objects/:apiName",
    component: <CustomObjectList />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "Custom Object Detail",
    key: "custom-object-detail",
    icon: <Icon fontSize="small">extension</Icon>,
    route: "/custom-objects/:apiName/:recordId",
    component: <CustomObjectDetail />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "Custom Objects Settings",
    key: "custom-objects-settings",
    icon: <Icon fontSize="small">extension</Icon>,
    route: "/settings/custom-objects",
    component: <CustomObjectsSettingsPage />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "Roles & Permissions",
    key: "roles-permissions",
    icon: <Icon fontSize="small">admin_panel_settings</Icon>,
    route: "/settings/roles",
    component: <RolesPermissions />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "Role Detail",
    key: "role-detail",
    icon: <Icon fontSize="small">admin_panel_settings</Icon>,
    route: "/settings/roles/:roleId",
    component: <RoleDetail />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "User",
    key: "settings-user-record",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/settings/users/:userId",
    component: <UserRecordV2 />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "Teams",
    key: "teams-settings",
    icon: <Icon fontSize="small">groups</Icon>,
    route: "/settings/teams",
    component: <TeamsSettings />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "Skills",
    key: "skills-settings",
    icon: <Icon fontSize="small">workspace_premium</Icon>,
    route: "/settings/skills",
    component: <SkillsSettings />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "Integrations Settings",
    key: "integrations-settings",
    icon: <Icon fontSize="small">extension</Icon>,
    route: "/settings/integrations",
    component: <IntegrationsSettingsPage />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "Messages",
    key: "messages",
    icon: <Icon fontSize="small">chat</Icon>,
    route: "/messages",
    component: <MessagesPage />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "Payment Settings",
    key: "payment-settings",
    icon: <Icon fontSize="small">payment</Icon>,
    route: "/settings/payments",
    component: <PaymentSettingsPage />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "Payment Gateway Setup",
    key: "payment-gateway-setup",
    icon: <Icon fontSize="small">payment</Icon>,
    route: "/settings/payments/:gateway",
    component: <PaymentGatewaySetupPage />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "Call Center",
    key: "call-center",
    icon: <Icon fontSize="small">headset_mic</Icon>,
    collapse: [
      {
        type: "collapse",
        name: "Call Console",
        key: "call-console",
        icon: <Icon fontSize="small">support_agent</Icon>,
        route: "/call-console",
        component: <CallConsole />,
        hideInSidenav: false,
      },
      {
        type: "route",
        name: "Call Detail",
        key: "call-detail",
        route: "/calls/:id",
        component: <CallDetail />,
        hideInSidenav: true,
      },
      {
        type: "collapse",
        name: "Supervisor",
        key: "supervisor-console",
        icon: <Icon fontSize="small">monitor_heart</Icon>,
        route: "/supervisor",
        component: <SupervisorConsole />,
        hideInSidenav: false,
      },
    ],
  },
  {
    type: "collapse",
    name: "Work Queues",
    key: "work-queues",
    icon: <Icon fontSize="small">move_to_inbox</Icon>,
    route: "/work",
    component: <WorkQueuesPage />,
    hideInSidenav: false,
  },
  {
    type: "collapse",
    name: "Agent Workload",
    key: "agent-workload",
    icon: <Icon fontSize="small">speed</Icon>,
    route: "/work/workload",
    component: <AgentWorkloadPage />,
    hideInSidenav: false,
  },
  {
    type: "collapse",
    name: "SEEP AI",
    key: "seep-ai-settings",
    icon: <SeepLogo size={20} />,
    route: "/settings/seep-ai",
    component: <SeepAISettingsPage />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "AI Assistant",
    key: "ai-assistant-settings",
    icon: <Icon fontSize="small">auto_awesome</Icon>,
    route: "/settings/ai-assistant",
    component: <AiAssistantSettingsPage />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "Developer & API",
    key: "developer-settings",
    icon: <Icon fontSize="small">key</Icon>,
    route: "/settings/developer",
    component: <DeveloperSettingsPage />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "Connected apps",
    key: "connected-apps",
    icon: <Icon fontSize="small">apps</Icon>,
    route: "/settings/connected-apps",
    component: <ConnectedApps />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "Authorise app",
    key: "oauth-consent",
    icon: <Icon fontSize="small">verified_user</Icon>,
    route: "/oauth/consent",
    component: <OAuthConsent />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "Real Estate Settings",
    key: "re-settings",
    icon: <Icon fontSize="small">apartment</Icon>,
    route: "/settings/real-estate",
    component: <RealEstateSettingsPage />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "Telephony Settings",
    key: "telephony-settings",
    icon: <Icon fontSize="small">settings_phone</Icon>,
    route: "/settings/telephony",
    component: <TelephonySettingsPage />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "Twilio Setup",
    key: "telephony-setup",
    icon: <Icon fontSize="small">settings_phone</Icon>,
    route: "/settings/telephony/twilio",
    component: <TwilioSetupPage />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "Phone Numbers",
    key: "telephony-numbers",
    icon: <Icon fontSize="small">dialpad</Icon>,
    route: "/settings/telephony/numbers",
    component: <TelephonyNumbersPage />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "Queues & Routing",
    key: "telephony-routing",
    icon: <Icon fontSize="small">alt_route</Icon>,
    route: "/settings/telephony/routing",
    component: <TelephonyRoutingPage />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "Recording & Transcription",
    key: "telephony-recording",
    icon: <Icon fontSize="small">graphic_eq</Icon>,
    route: "/settings/telephony/recording",
    component: <TelephonyRecordingPage />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "Phone Menus",
    key: "telephony-ivr",
    icon: <Icon fontSize="small">dialpad</Icon>,
    route: "/settings/telephony/ivr",
    component: <TelephonyIvrPage />,
    hideInSidenav: true,
  },
  // Queues outgrew telephony settings once they could hold cases and leads, so
  // they live under /settings rather than /settings/telephony. The voice-only
  // fields stay on the telephony page and the two link to each other.
  {
    type: "collapse",
    name: "Queues",
    key: "queues-settings",
    icon: <Icon fontSize="small">move_to_inbox</Icon>,
    route: "/settings/queues",
    component: <QueuesSettingsPage />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "Capacity & Work Item Values",
    key: "queue-capacity-settings",
    icon: <Icon fontSize="small">speed</Icon>,
    route: "/settings/queues/capacity",
    component: <QueueCapacityPage />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "Email to Case Settings",
    key: "email-to-case-settings",
    icon: <Icon fontSize="small">alternate_email</Icon>,
    route: "/settings/email-to-case",
    component: <EmailToCaseSettingsPage />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "New Custom Object",
    key: "custom-object-designer-new",
    icon: <Icon fontSize="small">extension</Icon>,
    route: "/settings/custom-objects/new",
    component: <CustomObjectDesigner />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "Edit Custom Object",
    key: "custom-object-designer-edit",
    icon: <Icon fontSize="small">extension</Icon>,
    route: "/settings/custom-objects/:id/edit",
    component: <CustomObjectDesigner />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "Deals",
    key: "deals",
    icon: <Icon fontSize="small">local_offer</Icon>,
    route: "/deals",
    component: <Deals />,
  },
  {
    type: "collapse",
    name: "Deals Detail",
    key: "deals-detail",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/deals/:id",
    component: <DealDetail />,
  },
  {
    type: "collapse",
    name: "Products",
    key: "products",
    icon: <Icon fontSize="small">inventory</Icon>,
    route: "/products",
    component: <Inventory />,
  },
  {
    type: "collapse",
    name: "Product Detail",
    key: "product-detail",
    icon: <Icon fontSize="small">inventory</Icon>,
    route: "/products/:id",
    component: <ProductDetail />,
  },
  {
    type: "collapse",
    name: "Quotations",
    key: "quotation",
    icon: <Icon fontSize="small">request_quote</Icon>,
    route: "/quote",
    component: <Quotation />,
  },
  {
    type: "collapse",
    name: "Orders",
    key: "orders",
    icon: <Icon fontSize="small">shopping_cart</Icon>,
    route: "/orders",
    component: <Orders />,
  },


  {
    type: "collapse",
    name: "OrderDetail",
    key: "order-detail",
    icon: <Icon fontSize="small">shopping_cart</Icon>,
    route: "/orders/:id",
    component: <OrderDetail />,
  },
  {
    type: "collapse",
    name: "Quotation Detail",
    key: "quotation-detail",
    icon: <Icon fontSize="small">request_quote</Icon>,
    route: "/quote/:id",
    component: <QuotationDetail />,
  },
  {
    type: "collapse",
    name: "Lead Detail",
    key: "lead-detail",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/leads/:id",
    component: <LeadDetail />,
  },
  {
    type: "collapse",
    name: "Account Detail",
    key: "account-detail",
    icon: <Icon fontSize="small">business</Icon>,
    route: "/accounts/:id",
    component: <AccountDetail />,
  },

  {
    type: "collapse",
    name: "Customer 360° View",
    key: "customer-360-view",
    icon: <Icon fontSize="small">360</Icon>,
    route: "/account/360/:id",
    component: <Customer360Route />,
  },

  {
    type: "collapse",
    name: "Gmail Auth Callback",
    key: "gmail-auth-callback",
    icon: <Icon fontSize="small">email</Icon>,
    route: "/auth/gmail/callback",
    component: <GmailAuthCallback />,
  },

  {
    type: "collapse",
    name: "Settings",
    key: "settings",
    icon: <Icon fontSize="small">settings</Icon>,
    route: "/settings",
    component: <Settings />,
  },
  {
    type: "collapse",
    name: "Custom Module",
    key: "custom-module",
    icon: <Icon fontSize="small">article</Icon>,
    route: "/custom/:moduleId",
    component: <CustomModulePage />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "Automation Builder",
    key: "automation-builder",
    icon: <Icon fontSize="small">auto_fix_high</Icon>,
    route: "/automations",
    component: <AutomationBuilder />,
  },
  {
    // Website settings are reached directly from the tenant settings card. Keep
    // the route outside the Travel collapse so it is registered even when the
    // travel navigation group is hidden by a tenant entitlement refresh.
    type: "collapse",
    name: "Website",
    key: "website",
    icon: <Icon fontSize="small">public</Icon>,
    route: "/website",
    component: <WebsiteSettingsPage />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "Travel",
    key: "travel",
    icon: <Icon fontSize="small">flight</Icon>,
    collapse: [
      //   In use
      {
        type: "collapse",
        name: "Orders",
        key: "travel-orders-list",
        icon: <Icon fontSize="small">receipt_long</Icon>,
        route: "/travel-orders",
        component: <TravelOrders />,
        hideInSidenav: false,
      },
      // ------------------------------------------------------------
      //   TRIPS ROUTES
      // ------------------------------------------------------------
      {
        type: "collapse",
        name: "Travel Destinations",
        key: "trips",
        icon: <Icon fontSize="small">map</Icon>,
        route: "/trips",
        component: <Trips />,
        hideInSidenav: false,
      },
      {
        type: "route",
        name: "Create Trip",
        key: "trip-create",
        route: "/trips/new",
        component: <CreateTrip />,
        hideInSidenav: true,
      },
      {
        type: "route",
        name: "New Trip Package",
        key: "trip-package-new",
        route: "/trip-packages/new",
        component: <CreateTrip />,
        hideInSidenav: true,
      },
      {
        type: "route",
        name: "Edit Trip",
        key: "trip-edit",
        route: "/trips/:editTripId/edit",
        component: <CreateTrip />,
        hideInSidenav: true,
      },
      {
        type: "collapse",
        name: "Trip Packages",
        key: "trip-packages",
        icon: <Icon fontSize="small">inventory_2</Icon>,
        route: "/trip-packages",
        component: <TripPackages />,
        hideInSidenav: false,
      },
      {
        type: "route",
        name: "Edit Trip Package",
        key: "trip-package-edit",
        route: "/trips/:editTripId/packages/:editPackageId/edit",
        component: <CreateTrip />,
        hideInSidenav: true,
      },
      {
        type: "route",
        name: "Trip Package Detail",
        key: "trip-package-detail",
        route: "/trip-packages/detail/:packageId",
        component: <TripPackageDetail />,
        hideInSidenav: true,
      },
      {
        type: "collapse",
        name: "Travel Order Pax",
        key: "travel-order-pax",
        icon: <Icon fontSize="small">people</Icon>,
        route: "/travel-order-pax",
        component: <TravelOrderPax />,
        hideInSidenav: true,
      },
      //   In use
      {
        type: "collapse",
        name: "Payment Templates",
        key: "payment-templates",
        icon: <Icon fontSize="small">payments</Icon>,
        route: "/payment-templates",
        component: <PaymentTemplates />,
        hideInSidenav: false,
      },
      {
        type: "collapse",
        name: "Payment Transactions",
        key: "payment-transactions",
        icon: <Icon fontSize="small">payment</Icon>,
        route: "/payment-transactions",
        component: <PaymentTransactions />,
        hideInSidenav: false,
      },
      //   In use
      {
        type: "collapse",
        name: "Payment Template Detail",
        key: "payment-template-detail",
        icon: <Icon fontSize="small">payments</Icon>,
        route: "/payment-templates/:id",
        component: <PaymentTemplateDetail />,
        hideInSidenav: true,
      },
      //   In use
      {
        type: "collapse",
        name: "High Season Surcharges",
        key: "high-season-surcharge",
        icon: <Icon fontSize="small">payments</Icon>,
        route: "/hss",
        component: <HSS />,
        hideInSidenav: false,
      },
      //   In use
      {
        type: "collapse",
        name: "High Season Surcharge Detail",
        key: "high-season-surcharge-detail",
        icon: <Icon fontSize="small">payments</Icon>,
        route: "/hss/:id",
        component: <HSSDetail />,
        hideInSidenav: true,
      },
      {
        type: "collapse",
        name: "Trip Logistics",
        key: "package-components",
        icon: <Icon fontSize="small">extension</Icon>,
        route: "/trip-package-components",
        component: <TripEntityList entityKey="package-components" />,
        hideInSidenav: false,
      },
      {
        type: "collapse",
        name: "Departure Dates",
        key: "departure-dates",
        icon: <Icon fontSize="small">event</Icon>,
        route: "/trip-departure-dates",
        component: <TripEntityList entityKey="departure-dates" />,
        hideInSidenav: false,
      },
      {
        type: "collapse",
        name: "Itineraries",
        key: "itineraries",
        icon: <Icon fontSize="small">route</Icon>,
        route: "/trip-itineraries",
        component: <TripEntityList entityKey="itineraries" />,
        hideInSidenav: false,
      },
      {
        type: "collapse",
        name: "Itinerary Days",
        key: "itinerary-days",
        icon: <Icon fontSize="small">today</Icon>,
        route: "/trip-itinerary-days",
        component: <TripEntityList entityKey="itinerary-days" />,
        hideInSidenav: false,
      },
      {
        type: "collapse",
        name: "Itinerary Day Line Items",
        key: "itinerary-day-line-items",
        icon: <Icon fontSize="small">format_list_bulleted</Icon>,
        route: "/trip-itinerary-day-line-items",
        component: <TripEntityList entityKey="itinerary-day-line-items" />,
        hideInSidenav: false,
      },
      {
        type: "collapse",
        name: "Addons",
        key: "addons",
        icon: <Icon fontSize="small">add_circle</Icon>,
        route: "/trip-addons",
        component: <TripEntityList entityKey="addons" />,
        hideInSidenav: false,
      },
      {
        type: "collapse",
        name: "FAQs",
        key: "trip-faqs",
        icon: <Icon fontSize="small">help_outline</Icon>,
        route: "/trip-faqs",
        component: <TripEntityList entityKey="faqs" />,
        hideInSidenav: false,
      },
      {
        type: "collapse",
        name: "Trip Package Detail",
        key: "trip-package-detail",
        route: "/trip-packages/:id",
        component: <TripEntityDetail entityKey="trip-packages" />,
        hideInSidenav: true,
      },
      {
        type: "collapse",
        name: "Trip Logistics Detail",
        key: "package-component-detail",
        route: "/trip-package-components/:id",
        component: <TripEntityDetail entityKey="package-components" />,
        hideInSidenav: true,
      },
      {
        type: "collapse",
        name: "Departure Date Detail",
        key: "departure-date-detail",
        route: "/trip-departure-dates/:id",
        component: <TripEntityDetail entityKey="departure-dates" />,
        hideInSidenav: true,
      },
      {
        type: "collapse",
        name: "Itinerary Detail",
        key: "trip-itinerary-detail",
        route: "/trip-itineraries/:id",
        component: <TripEntityDetail entityKey="itineraries" />,
        hideInSidenav: true,
      },
      {
        type: "collapse",
        name: "Itinerary Day Detail",
        key: "itinerary-day-detail",
        route: "/trip-itinerary-days/:id",
        component: <TripEntityDetail entityKey="itinerary-days" />,
        hideInSidenav: true,
      },
      {
        type: "collapse",
        name: "Itinerary Day Line Item Detail",
        key: "itinerary-day-line-item-detail",
        route: "/trip-itinerary-day-line-items/:id",
        component: <TripEntityDetail entityKey="itinerary-day-line-items" />,
        hideInSidenav: true,
      },
      {
        type: "collapse",
        name: "Addon Detail",
        key: "trip-addon-detail",
        route: "/trip-addons/:id",
        component: <TripEntityDetail entityKey="addons" />,
        hideInSidenav: true,
      },
      {
        type: "collapse",
        name: "FAQ Detail",
        key: "trip-faq-detail",
        route: "/trip-faqs/:id",
        component: <TripEntityDetail entityKey="faqs" />,
        hideInSidenav: true,
      },
      {
        type: "collapse",
        name: "CMS Publisher",
        key: "cms-publisher",
        icon: <Icon fontSize="small">public</Icon>,
        route: "/cms-publisher",
        component: <CMSPublishers />,
        hideInSidenav: true,
      },
      {
        type: "collapse",
        name: "Guide Allocations",
        key: "guide-allocations",
        icon: <Icon fontSize="small">assignment_ind</Icon>,
        route: "/guide-allocations",
        component: <GuideAllocations />,
        hideInSidenav: true,
      },
      {
        type: "collapse",
        name: "Creator Onboardings",
        key: "creator-onboardings",
        icon: <Icon fontSize="small">person_add</Icon>,
        route: "/creator-onboardings",
        component: <CreatorOnboardings />,
        hideInSidenav: true,
      },
      {
        type: "collapse",
        name: "Creators",
        key: "creators",
        icon: <Icon fontSize="small">star</Icon>,
        route: "/creators",
        component: <Creators />,
        hideInSidenav: true,
      },
      {
        type: "collapse",
        name: "Trip Options",
        key: "trip-options",
        icon: <Icon fontSize="small">settings</Icon>,
        route: "/trip-options",
        component: <TripOptions />,
        hideInSidenav: true,
      },
      {
        type: "collapse",
        name: "Trip Sub-Options",
        key: "trip-sub-options",
        icon: <Icon fontSize="small">settings</Icon>,
        route: "/trip-sub-options",
        component: <TripSubOptions />,
        hideInSidenav: true,
      },
      {
        type: "collapse",
        name: "Departure Dates",
        key: "departure-dates",
        icon: <Icon fontSize="small">event</Icon>,
        route: "/departure-dates",
        component: <DepartureDates />,
        hideInSidenav: true,
      },
      {
        type: "collapse",
        name: "Addons",
        key: "addons",
        icon: <Icon fontSize="small">add_circle</Icon>,
        route: "/addons",
        component: <Addons />,
        hideInSidenav: true,
      },
      {
        type: "collapse",
        name: "FAQs",
        key: "faqs",
        icon: <Icon fontSize="small">help</Icon>,
        route: "/faqs",
        component: <FAQs />,
        hideInSidenav: true,
      },
      {
        type: "collapse",
        name: "Itineraries",
        key: "itineraries",
        icon: <Icon fontSize="small">map</Icon>,
        route: "/itineraries",
        component: <Itineraries />,
        hideInSidenav: true,
      },
      {
        type: "collapse",
        name: "Itinerary Days",
        key: "itinerary-days",
        icon: <Icon fontSize="small">map</Icon>,
        route: "/itinerary-days",
        component: <ItineraryDays />,
        hideInSidenav: true,
      },
      {
        type: "collapse",
        name: "Itinerary Day Line Items",
        key: "itinerary-day-line-items",
        icon: <Icon fontSize="small">list</Icon>,
        route: "/itinerary-day-line-items",
        component: <ItineraryDayLineItems />,
        hideInSidenav: true,
      },
      {
        type: "collapse",
        name: "Day Line Items",
        key: "day-line-items",
        icon: <Icon fontSize="small">list</Icon>,
        route: "/day-line-items",
        component: <DayLineItems />,
        hideInSidenav: true,
      },
      {
        type: "collapse",
        name: "Trip Logistics",
        key: "trip-components",
        icon: <Icon fontSize="small">view_module</Icon>,
        route: "/trip-components",
        component: <TripComponents />,
        hideInSidenav: true,
      },
      {
        type: "collapse",
        name: "Merchant Assets",
        key: "merchant-assets",
        icon: <Icon fontSize="small">store</Icon>,
        route: "/merchant-assets",
        component: <MerchantAssets />,
        hideInSidenav: false,
      },
      {
        type: "collapse",
        name: "Merchant Asset Inventory",
        key: "merchant-asset-inventories",
        icon: <Icon fontSize="small">inventory</Icon>,
        route: "/merchant-asset-inventories",
        component: <MerchantAssetInventories />,
        hideInSidenav: true,
      },
      {
        type: "collapse",
        name: "Merchant Allocation",
        key: "merchant-allocations",
        icon: <Icon fontSize="small">assignment</Icon>,
        route: "/merchant-allocations",
        component: <TripEntityList entityKey="merchant-allocations" />,
        hideInSidenav: false,
      },
      {
        type: "collapse",
        name: "Merchant Allocation Detail",
        key: "merchant-allocations-detail",
        route: "/merchant-allocations/:id",
        component: <MerchantAllocationDetail />,
        hideInSidenav: true,
      },
      {
        type: "collapse",
        name: "Merchant Order Lines",
        key: "merchant-order-lines",
        icon: <Icon fontSize="small">list</Icon>,
        route: "/merchant-order-lines",
        component: <MerchantOrderLines />,
        hideInSidenav: false,
      },
      {
        type: "collapse",
        name: "Training Modules",
        key: "training-modules",
        icon: <Icon fontSize="small">school</Icon>,
        route: "/training-modules",
        component: <TrainingModules />,
        hideInSidenav: true,
      },
      {
        type: "collapse",
        name: "Training Completions",
        key: "training-completions",
        icon: <Icon fontSize="small">check_circle</Icon>,
        route: "/training-completions",
        component: <TrainingCompletions />,
        hideInSidenav: true,
      },
      {
        type: "collapse",
        name: "Payment Terms",
        key: "payment-terms",
        icon: <Icon fontSize="small">payments</Icon>,
        route: "/payment-terms",
        component: <PaymentTerms />,
        hideInSidenav: true,
      },
      // Travel Orders moved to top-level sidebar below Travel
      // {
      //   type: "collapse",
      //   name: "Travel Orders",
      //   key: "travel-orders",
      //   icon: <Icon fontSize="small">receipt_long</Icon>,
      //   route: "/travel-orders",
      //   component: <TravelOrders />,
      //   hideInSidenav: true,
      // },
      {
        type: "collapse",
        name: "Insurances",
        key: "insurances",
        icon: <Icon fontSize="small">security</Icon>,
        route: "/insurances",
        component: <Insurances />,
        hideInSidenav: true,
      },
      {
        type: "collapse",
        name: "Travel Order Items",
        key: "travel-order-items",
        icon: <Icon fontSize="small">list_alt</Icon>,
        route: "/travel-order-items",
        component: <TravelOrderItems />,
        hideInSidenav: true,
      },
      {
        type: "collapse",
        name: "Travel Order Item Passengers",
        key: "travel-order-item-pax",
        icon: <Icon fontSize="small">person_add</Icon>,
        route: "/travel-order-item-pax",
        component: <TravelOrderItemPax />,
        hideInSidenav: true,
      },
      {
        type: "collapse",
        name: "Order Itineraries",
        key: "order-itineraries",
        icon: <Icon fontSize="small">route</Icon>,
        route: "/order-itineraries",
        component: <OrderItineraries />,
        hideInSidenav: true,
      },
      {
        type: "collapse",
        name: "Order Coupons",
        key: "order-coupons",
        icon: <Icon fontSize="small">local_offer</Icon>,
        route: "/order-coupons",
        component: <OrderCoupons />,
        hideInSidenav: true,
      },
      {
        type: "collapse",
        name: "Order Comms",
        key: "order-comms",
        icon: <Icon fontSize="small">email</Icon>,
        route: "/order-comms",
        component: <OrderComms />,
        hideInSidenav: true,
      },
      {
        type: "collapse",
        name: "Coupons",
        key: "coupons",
        icon: <Icon fontSize="small">local_offer</Icon>,
        route: "/coupons",
        component: <Coupons />,
        hideInSidenav: true,
      },
      // Payment Transactions moved to Travel Order sidenav
      // {
      //   type: "collapse",
      //   name: "Payment Transactions",
      //   key: "payment-transactions",
      //   icon: <Icon fontSize="small">payment</Icon>,
      //   route: "/payment-transactions",
      //   component: <PaymentTransactions />,
      //   hideInSidenav: true,
      // },
      {
        type: "collapse",
        name: "Order Cancellations",
        key: "order-cancellations",
        icon: <Icon fontSize="small">cancel</Icon>,
        route: "/order-cancellations",
        component: <OrderCancellations />,
        hideInSidenav: true,
      },
      {
        type: "collapse",
        name: "Merchants",
        key: "merchants",
        icon: <Icon fontSize="small">store</Icon>,
        route: "/merchants",
        component: <Merchants />,
        hideInSidenav: true,
      },
      {
        type: "collapse",
        name: "Travel Contacts",
        key: "travel-contacts",
        icon: <Icon fontSize="small">person</Icon>,
        route: "/travel-contacts",
        component: <TravelContacts />,
        hideInSidenav: true,
      },
      {
        type: "collapse",
        name: "Opportunities",
        key: "opportunities",
        icon: <Icon fontSize="small">trending_up</Icon>,
        route: "/opportunities",
        component: <Opportunities />,
        hideInSidenav: true,
      },
      {
        type: "collapse",
        name: "Customers",
        key: "customers",
        icon: <Icon fontSize="small">people</Icon>,
        route: "/customers",
        component: <Customers />,
        hideInSidenav: true,
      },
      {
        type: "collapse",
        name: "Pricing Categories",
        key: "pricing-categories",
        icon: <Icon fontSize="small">price_check</Icon>,
        route: "/pricing-categories",
        component: <PricingCategories />,
        hideInSidenav: true,
      },
      {
        type: "collapse",
        name: "Customer Coupons",
        key: "customer-coupons",
        icon: <Icon fontSize="small">card_giftcard</Icon>,
        route: "/customer-coupons",
        component: <CustomerCoupons />,
        hideInSidenav: true,
      },
      {
        type: "collapse",
        name: "Loyalty Rules",
        key: "loyalty-rules",
        icon: <Icon fontSize="small">rule</Icon>,
        route: "/loyalty-rules",
        component: <LoyaltyRules />,
        hideInSidenav: true,
      },
      {
        type: "collapse",
        name: "Loyalty Ledgers",
        key: "loyalty-ledgers",
        icon: <Icon fontSize="small">account_balance_wallet</Icon>,
        route: "/loyalty-ledgers",
        component: <LoyaltyLedgers />,
        hideInSidenav: true,
      },
      {
        type: "collapse",
        name: "Loyalty Summaries",
        key: "loyalty-summaries",
        icon: <Icon fontSize="small">summarize</Icon>,
        route: "/loyalty-summaries",
        component: <LoyaltySummaries />,
        hideInSidenav: true,
      },
      {
        type: "collapse",
        name: "Loyalty Tiers",
        key: "loyalty-tiers",
        icon: <Icon fontSize="small">star_rate</Icon>,
        route: "/loyalty-tiers",
        component: <LoyaltyTiers />,
        hideInSidenav: true,
      },
      {
        type: "collapse",
        name: "Loyalty Tier Detail",
        key: "loyalty-tier-detail",
        icon: <Icon fontSize="small">star_rate</Icon>,
        route: "/loyalty-tiers/:id",
        component: <LoyaltyTierDetail />,
        hideInSidenav: true,
      },
      {
        type: "collapse",
        name: "Referral Redemptions",
        key: "referral-redemptions",
        icon: <Icon fontSize="small">swap_horizontal_circle</Icon>,
        route: "/referral-redemptions",
        component: <ReferralRedemptions />,
        hideInSidenav: true,
      },
      {
        type: "collapse",
        name: "Referral Redemption Detail",
        key: "referral-redemption-detail",
        icon: <Icon fontSize="small">swap_horizontal_circle</Icon>,
        route: "/referral-redemptions/:id",
        component: <ReferralRedemptionDetail />,
        hideInSidenav: true,
      },
      {
        type: "collapse",
        name: "Referral Program Settings",
        key: "referral-program-settings",
        icon: <Icon fontSize="small">settings_applications</Icon>,
        route: "/referral-program-settings",
        component: <ReferralProgramSettings />,
        hideInSidenav: true,
      },
      {
        type: "collapse",
        name: "Referral Program Setting Detail",
        key: "referral-program-setting-detail",
        icon: <Icon fontSize="small">settings_applications</Icon>,
        route: "/referral-program-settings/:id",
        component: <ReferralProgramSettingDetail />,
        hideInSidenav: true,
      },
      {
        type: "collapse",
        name: "Guide Onboardings",
        key: "guide-onboardings",
        icon: <Icon fontSize="small">person_add_alt</Icon>,
        route: "/guide-onboardings",
        component: <GuideOnboardings />,
        hideInSidenav: true,
      },
      {
        type: "collapse",
        name: "Guide Onboarding Detail",
        key: "guide-onboarding-detail",
        icon: <Icon fontSize="small">person_add_alt</Icon>,
        route: "/guide-onboardings/:id",
        component: <GuideOnboardingDetail />,
        hideInSidenav: true,
      },

      {
        type: "collapse",
        name: "Email Setup",
        key: "email-setup",
        icon: <Icon fontSize="small">email</Icon>,
        route: "/email-setup",
        component: <EmailSetup />,
        hideInSidenav: true,
      },
      {
        type: "collapse",
        name: "Invoices",
        key: "invoices",
        icon: <Icon fontSize="small">receipt</Icon>,
        route: "/invoices",
        component: <Invoices />,
        hideInSidenav: true,
      },
    ]
  },
  // {
  //   type: "collapse",
  //   name: "Travel Order",
  //   key: "travel-orders",
  //   icon: <Icon fontSize="small">luggage</Icon>,
  //   collapse: [
  //     {
  //       type: "collapse",
  //       name: "Travel Order",
  //       key: "travel-orders-list",
  //       icon: <Icon fontSize="small">receipt_long</Icon>,
  //       route: "/travel-orders",
  //       component: <TravelOrders />,
  //       hideInSidenav: false,
  //     },
  //     {
  //       type: "collapse",
  //       name: "Order Pax",
  //       key: "travel-order-pax",
  //       icon: <Icon fontSize="small">people</Icon>,
  //       route: "/travel-order-pax",
  //       component: <TravelOrderPax />,
  //       hideInSidenav: false,
  //     },
  //   ],
  // },
  // {
  //   type: "collapse",
  //   name: "Merchant",
  //   key: "merchant",
  //   icon: <Icon fontSize="small">store</Icon>,
  //   collapse: [
  //     {
  //       type: "collapse",
  //       name: "Merchant Assets",
  //       key: "merchant-assets",
  //       icon: <Icon fontSize="small">inventory_2</Icon>,
  //       route: "/merchant-assets",
  //       component: <MerchantAssets />,
  //       hideInSidenav: false,
  //     },
  //   ],
  // },
  {
    type: "collapse",
    name: "Trips",
    key: "trips",
    icon: <Icon fontSize="small">map</Icon>,
    route: "/trips",
    component: <Trips />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "CMS Publisher",
    key: "cms-publisher",
    icon: <Icon fontSize="small">public</Icon>,
    route: "/cms-publisher",
    component: <CMSPublishers />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "Guide Allocations",
    key: "guide-allocations",
    icon: <Icon fontSize="small">assignment_ind</Icon>,
    route: "/guide-allocations",
    component: <GuideAllocations />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "Creator Onboardings",
    key: "creator-onboardings",
    icon: <Icon fontSize="small">person_add</Icon>,
    route: "/creator-onboardings",
    component: <CreatorOnboardings />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "Creators",
    key: "creators",
    icon: <Icon fontSize="small">star</Icon>,
    route: "/creators",
    component: <Creators />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "Payment Templates",
    key: "payment-templates",
    icon: <Icon fontSize="small">payments</Icon>,
    route: "/payment-templates",
    component: <PaymentTemplates />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "Trip Options",
    key: "trip-options",
    icon: <Icon fontSize="small">settings</Icon>,
    route: "/trip-options",
    component: <TripOptions />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "Trip Sub-Options",
    key: "trip-sub-options",
    icon: <Icon fontSize="small">settings</Icon>,
    route: "/trip-sub-options",
    component: <TripSubOptions />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "Departure Dates",
    key: "departure-dates",
    icon: <Icon fontSize="small">event</Icon>,
    route: "/departure-dates",
    component: <DepartureDates />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "Addons",
    key: "addons",
    icon: <Icon fontSize="small">add_circle</Icon>,
    route: "/addons",
    component: <Addons />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "FAQs",
    key: "faqs",
    icon: <Icon fontSize="small">help</Icon>,
    route: "/faqs",
    component: <FAQs />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "Itineraries",
    key: "itineraries",
    icon: <Icon fontSize="small">map</Icon>,
    route: "/itineraries",
    component: <Itineraries />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "Itinerary Days",
    key: "itinerary-days",
    icon: <Icon fontSize="small">map</Icon>,
    route: "/itinerary-days",
    component: <ItineraryDays />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "Itinerary Day Line Items",
    key: "itinerary-day-line-items",
    icon: <Icon fontSize="small">list</Icon>,
    route: "/itinerary-day-line-items",
    component: <ItineraryDayLineItems />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "Day Line Items",
    key: "day-line-items",
    icon: <Icon fontSize="small">list</Icon>,
    route: "/day-line-items",
    component: <DayLineItems />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "Trip Logistics",
    key: "trip-components",
    icon: <Icon fontSize="small">view_module</Icon>,
    route: "/trip-components",
    component: <TripComponents />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "Training Modules",
    key: "training-modules",
    icon: <Icon fontSize="small">school</Icon>,
    route: "/training-modules",
    component: <TrainingModules />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "Training Completions",
    key: "training-completions",
    icon: <Icon fontSize="small">check_circle</Icon>,
    route: "/training-completions",
    component: <TrainingCompletions />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "Payment Terms",
    key: "payment-terms",
    icon: <Icon fontSize="small">payments</Icon>,
    route: "/payment-terms",
    component: <PaymentTerms />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "Merchant Asset Inventories",
    key: "merchant-asset-inventories",
    icon: <Icon fontSize="small">inventory</Icon>,
    route: "/merchant-asset-inventories",
    component: <MerchantAssetInventories />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "Merchant Allocations",
    key: "merchant-allocations-legacy",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/merchant-allocations-legacy",
    component: <MerchantAllocations />,
    hideInSidenav: true,
  },
  // Duplicate — primary Travel Orders route is below Travel collapse
  // {
  //   type: "collapse",
  //   name: "Travel Orders",
  //   key: "travel-orders",
  //   icon: <Icon fontSize="small">receipt_long</Icon>,
  //   route: "/travel-orders",
  //   component: <TravelOrders />,
  //   hideInSidenav: true,
  // },
  {
    type: "collapse",
    name: "Insurances",
    key: "insurances",
    icon: <Icon fontSize="small">security</Icon>,
    route: "/insurances",
    component: <Insurances />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "Travel Order Items",
    key: "travel-order-items",
    icon: <Icon fontSize="small">list_alt</Icon>,
    route: "/travel-order-items",
    component: <TravelOrderItems />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "Travel Order Item Passengers",
    key: "travel-order-item-pax",
    icon: <Icon fontSize="small">person_add</Icon>,
    route: "/travel-order-item-pax",
    component: <TravelOrderItemPax />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "Order Itineraries",
    key: "order-itineraries",
    icon: <Icon fontSize="small">route</Icon>,
    route: "/order-itineraries",
    component: <OrderItineraries />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "Order Coupons",
    key: "order-coupons",
    icon: <Icon fontSize="small">local_offer</Icon>,
    route: "/order-coupons",
    component: <OrderCoupons />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "Order Comms",
    key: "order-comms",
    icon: <Icon fontSize="small">email</Icon>,
    route: "/order-comms",
    component: <OrderComms />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "Coupons",
    key: "coupons",
    icon: <Icon fontSize="small">local_offer</Icon>,
    route: "/coupons",
    component: <Coupons />,
    hideInSidenav: true,
  },
  // Duplicate — primary Payment Transactions route is under Travel Order collapse
  // {
  //   type: "collapse",
  //   name: "Payment Transactions",
  //   key: "payment-transactions",
  //   icon: <Icon fontSize="small">payment</Icon>,
  //   route: "/payment-transactions",
  //   component: <PaymentTransactions />,
  //   hideInSidenav: true,
  // },
  {
    type: "collapse",
    name: "Order Cancellations",
    key: "order-cancellations",
    icon: <Icon fontSize="small">cancel</Icon>,
    route: "/order-cancellations",
    component: <OrderCancellations />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "Merchants",
    key: "merchants",
    icon: <Icon fontSize="small">store</Icon>,
    route: "/merchants",
    component: <Merchants />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "Travel Contacts",
    key: "travel-contacts",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/travel-contacts",
    component: <TravelContacts />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "Opportunities",
    key: "opportunities",
    icon: <Icon fontSize="small">trending_up</Icon>,
    route: "/opportunities",
    component: <Opportunities />,
  },
  {
    type: "collapse",
    name: "Customers",
    key: "customers",
    icon: <Icon fontSize="small">people</Icon>,
    route: "/customers",
    component: <Customers />,
  },
  {
    type: "collapse",
    name: "Pricing Categories",
    key: "pricing-categories",
    icon: <Icon fontSize="small">price_check</Icon>,
    route: "/pricing-categories",
    component: <PricingCategories />,
  },
  {
    type: "collapse",
    name: "Customer Coupons",
    key: "customer-coupons",
    icon: <Icon fontSize="small">card_giftcard</Icon>,
    route: "/customer-coupons",
    component: <CustomerCoupons />,
  },
  {
    type: "collapse",
    name: "Loyalty Rules",
    key: "loyalty-rules",
    icon: <Icon fontSize="small">rule</Icon>,
    route: "/loyalty-rules",
    component: <LoyaltyRules />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "Loyalty Ledgers",
    key: "loyalty-ledgers",
    icon: <Icon fontSize="small">account_balance_wallet</Icon>,
    route: "/loyalty-ledgers",
    component: <LoyaltyLedgers />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "Loyalty Summaries",
    key: "loyalty-summaries",
    icon: <Icon fontSize="small">summarize</Icon>,
    route: "/loyalty-summaries",
    component: <LoyaltySummaries />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "Loyalty Tiers",
    key: "loyalty-tiers",
    icon: <Icon fontSize="small">star_rate</Icon>,
    route: "/loyalty-tiers",
    component: <LoyaltyTiers />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "Loyalty Tier Detail",
    key: "loyalty-tier-detail",
    icon: <Icon fontSize="small">star_rate</Icon>,
    route: "/loyalty-tiers/:id",
    component: <LoyaltyTierDetail />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "Referral Redemptions",
    key: "referral-redemptions",
    icon: <Icon fontSize="small">swap_horizontal_circle</Icon>,
    route: "/referral-redemptions",
    component: <ReferralRedemptions />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "Referral Redemption Detail",
    key: "referral-redemption-detail",
    icon: <Icon fontSize="small">swap_horizontal_circle</Icon>,
    route: "/referral-redemptions/:id",
    component: <ReferralRedemptionDetail />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "Referral Program Settings",
    key: "referral-program-settings",
    icon: <Icon fontSize="small">settings_applications</Icon>,
    route: "/referral-program-settings",
    component: <ReferralProgramSettings />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "Referral Program Setting Detail",
    key: "referral-program-setting-detail",
    icon: <Icon fontSize="small">settings_applications</Icon>,
    route: "/referral-program-settings/:id",
    component: <ReferralProgramSettingDetail />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "Guide Onboardings",
    key: "guide-onboardings",
    icon: <Icon fontSize="small">person_add_alt</Icon>,
    route: "/guide-onboardings",
    component: <GuideOnboardings />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "Guide Onboarding Detail",
    key: "guide-onboarding-detail",
    icon: <Icon fontSize="small">person_add_alt</Icon>,
    route: "/guide-onboardings/:id",
    component: <GuideOnboardingDetail />,
    hideInSidenav: true,
  },

  {
    type: "collapse",
    name: "Email Setup",
    key: "email-setup",
    icon: <Icon fontSize="small">email</Icon>,
    route: "/email-setup",
    component: <EmailSetup />,
  },
  {
    type: "collapse",
    name: "Invoices",
    key: "invoices",
    icon: <Icon fontSize="small">receipt</Icon>,
    route: "/invoices",
    component: <Invoices />,
  },
  {
    type: "collapse",
    name: "Company Settings",
    key: "company-settings",
    icon: <Icon fontSize="small">receipt</Icon>,
    route: "/settings/company-settings",
    component: <CompanySettings />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "Merchant Service Requests",
    key: "merchant-service-request-settings",
    icon: <Icon fontSize="small">mail</Icon>,
    route: "/settings/merchant-service-requests",
    component: <MerchantServiceRequestSettings />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "Search",
    key: "search",
    icon: <Icon fontSize="small">search</Icon>,
    route: "/search",
    component: <SearchResults />,
  },
  {
    type: "route",
    name: "Profile",
    key: "profile",
    route: "/profile",
    component: <UserProfile />,
    icon: <Icon>person</Icon>,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "View User Profile",
    key: "view-user-profile",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/users/:userId/profile",
    component: <ViewUserProfile />,
    noCollapse: true,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "Create Password",
    key: "create-password",
    icon: <Icon fontSize="small">password</Icon>,
    route: "/create-password",
    component: <CreatePasswordPage />,
  },
  {
    type: "collapse",
    name: "Reset Password",
    key: "reset-password", // Remove the :token parameter
    icon: <Icon fontSize="small">password</Icon>,
    route: "/reset-password",
    component: <ResetPassword />,
    noCollapse: true,
    protected: false // Add this flag to indicate it's not a protected route
  },

  { type: "divider", key: "divider" },
  { type: "title", title: "Support", key: "title-pages1" },
  {
    type: "collapse",
    name: "Cases",
    key: "cases",
    icon: <SupportAgentIcon fontSize="small" />,
    route: "/cases",
    component: <Cases />,
  },
  {
    type: "collapse",
    name: "Case Detail",
    key: "case-detail",
    icon: <SupportAgentIcon fontSize="small" />,
    route: "/cases/:id",
    component: <CaseDetail />,
  },

  { type: "divider", key: "divider-1" },
  { type: "title", title: "Productivity", key: "title-pages" },
  {
    type: "collapse",
    name: "Tasks",
    key: "tasks",
    icon: <Icon fontSize="small">event</Icon>,
    route: "/tasks",
    component: <Tasks />,
  },
  {
    type: "collapse",
    name: "Inbox",
    key: "inbox",
    icon: <Icon fontSize="small">email</Icon>,
    route: "/inbox",
    component: <Inbox />,
  },

  {
    type: "collapse",
    name: "Dashboards",
    key: "dashboards",
    icon: <Icon fontSize="small">dashboard_customize</Icon>,
    route: "/dashboards",
    component: <DashboardsList />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard-detail",
    route: "/dashboards/:dashboardId",
    component: <DashboardPage />,
  },
  {
    type: "collapse",
    name: "Reports",
    key: "reports",
    icon: <Icon fontSize="small">assessment</Icon>,
    route: "/reports",
    component: <ReportsHome />,
    noCollapse: true,
    // The old entry carried protected: false. It was inert — App.js decides
    // what is public from its own list, and /reports was never on it — but it
    // read as a claim that the reports page is unauthenticated, which it is
    // not and must not become.
  },
  // Detail routes. React Router v6 ranks by specificity, so /reports/new is
  // matched ahead of /reports/:reportId regardless of declaration order.
  {
    type: "collapse",
    name: "New Report",
    key: "report-new",
    route: "/reports/new",
    component: <ReportBuilder />,
  },
  {
    type: "collapse",
    name: "Edit Report",
    key: "report-edit",
    route: "/reports/:reportId/edit",
    component: <ReportBuilder />,
  },
  {
    type: "collapse",
    name: "Report",
    key: "report-detail",
    route: "/reports/:reportId",
    component: <ReportViewer />,
  },
  { type: "divider", key: "divider" },



  {
    type: "collapse",
    name: "Agent Map",
    key: "agent-map",
    icon: <Icon fontSize="small">map</Icon>,
    route: "/agent-map",
    component: <AgentMap />,
  },

  {
    type: "collapse",
    name: "Support Ticket",
    key: "support-ticket",
    icon: <Icon fontSize="small">support</Icon>,
    route: "/support-ticket",
    component: <SupportTicket />,
  },
  {
    type: "collapse",
    name: "Invoice Detail",
    key: "invoice-detail",
    icon: <Icon fontSize="small">receipt</Icon>,
    route: "/invoices/:id",
    component: <InvoiceDetail />,
  },
  {
    type: "route",
    name: "Trip Detail",
    key: "trip-detail",
    route: "/trips/:id",
    component: <TripDetail />,
    hideInSidenav: true,
  },
  {
    type: "route",
    name: "CMS Publisher Detail",
    key: "cms-publisher-detail",
    route: "/cms-publisher/:id",
    component: <CMSPublisherDetail />,
    hideInSidenav: true,
  },
  {
    type: "route",
    name: "Guide Allocation Detail",
    key: "guide-allocation-detail",
    route: "/guide-allocation/:id",
    component: <GuideAllocationDetail />,
    hideInSidenav: true,
  },
  {
    type: "route",
    name: "Creator Onboarding Detail",
    key: "creator-onboarding-detail",
    route: "/creator-onboarding/:id",
    component: <CreatorOnboardingDetail />,
    hideInSidenav: true,
  },
  {
    type: "route",
    name: "Creator Detail",
    key: "creator-detail",
    route: "/creator/:id",
    component: <CreatorDetail />,
    hideInSidenav: true,
  },
  {
    type: "route",
    name: "Trip Option Detail",
    key: "trip-option-detail",
    route: "/trip-options/:id",
    component: <TripOptionDetail />,
    hideInSidenav: true,
  },
  {
    type: "route",
    name: "Trip Sub-Option Detail",
    key: "trip-sub-option-detail",
    route: "/trip-sub-options/:id",
    component: <TripSubOptionDetail />,
    hideInSidenav: true,
  },
  {
    type: "route",
    name: "Departure Date Detail",
    key: "departure-date-detail",
    route: "/departure-dates/:id",
    component: <DepartureDateDetail />,
    hideInSidenav: true,
  },
  {
    type: "route",
    name: "Addon Detail",
    key: "addon-detail",
    route: "/addons/:id",
    component: <AddonDetail />,
    hideInSidenav: true,
  },
  {
    type: "route",
    name: "FAQ Detail",
    key: "faq-detail",
    route: "/faqs/:id",
    component: <FAQDetail />,
    hideInSidenav: true,
  },
  {
    type: "route",
    name: "Itinerary Detail",
    key: "itinerary-detail",
    route: "/itineraries/:id",
    component: <ItineraryDetail />,
    hideInSidenav: true,
  },
  {
    type: "route",
    name: "Itinerary Day Detail",
    key: "itinerary-day-detail",
    route: "/itinerary-days/:id",
    component: <ItineraryDayDetail />,
    hideInSidenav: true,
  },
  {
    type: "route",
    name: "Itinerary Day Line Item Detail",
    key: "itinerary-day-line-item-detail",
    route: "/itinerary-day-line-items/:id",
    component: <ItineraryDayLineItemDetail />,
    hideInSidenav: true,
  },
  {
    type: "route",
    name: "Day Line Item Detail",
    key: "day-line-item-detail",
    route: "/day-line-items/:id",
    component: <DayLineItemDetail />,
    hideInSidenav: true,
  },
  {
    type: "route",
    name: "Trip Logistics Detail",
    key: "trip-component-detail",
    route: "/trip-components/:id",
    component: <TripComponentDetail />,
    hideInSidenav: true,
  },
  {
    type: "route",
    name: "Merchant Asset Detail",
    key: "merchant-asset-detail",
    route: "/merchant-assets/:id",
    component: <MerchantAssetDetail />,
    hideInSidenav: true,
  },
  {
    type: "route",
    name: "Training Module Detail",
    key: "training-module-detail",
    route: "/training-modules/:id",
    component: <TrainingModuleDetail />,
    hideInSidenav: true,
  },
  {
    type: "route",
    name: "Training Completion Detail",
    key: "training-completion-detail",
    route: "/training-completion/:id",
    component: <TrainingCompletionDetail />,
    hideInSidenav: true,
  },
  {
    type: "route",
    name: "Payment Term Detail",
    key: "payment-term-detail",
    route: "/payment-term/:id",
    component: <PaymentTermDetail />,
    hideInSidenav: true,
  },
  {
    type: "route",
    name: "Merchant Asset Inventory Detail",
    key: "merchant-asset-inventory-detail",
    route: "/merchant-asset-inventory/:id",
    component: <MerchantAssetInventoryDetail />,
    hideInSidenav: true,
  },
  {
    type: "route",
    name: "Merchant Allocation Detail",
    key: "merchant-allocation-detail",
    route: "/merchant-allocation/:id",
    component: <MerchantAllocationDetail />,
    hideInSidenav: true,
  },
  {
    type: "route",
    name: "Travel Order Detail",
    key: "travel-order-detail",
    route: "/travel-order/:id",
    component: <TravelOrderDetailView />,
    hideInSidenav: true,
  },
  {
    type: "route",
    name: "Insurance Detail",
    key: "insurance-detail",
    route: "/insurance/:id",
    component: <InsuranceDetail />,
    hideInSidenav: true,
  },
  {
    type: "route",
    name: "Travel Order Item Detail",
    key: "travel-order-item-detail",
    route: "/travel-order-item/:id",
    component: <TravelOrderItemDetail />,
    hideInSidenav: true,
  },
  {
    type: "route",
    name: "Travel Order Pax Detail",
    key: "travel-order-pax-detail",
    route: "/travel-order-pax/:id",
    component: <TravelOrderPaxDetail />,
    hideInSidenav: true,
  },
  {
    type: "route",
    name: "Travel Order Item Pax Detail",
    key: "travel-order-item-pax-detail",
    route: "/travel-order-item-pax/:id",
    component: <TravelOrderItemPaxDetail />,
    hideInSidenav: true,
  },
  {
    type: "route",
    name: "Order Itinerary Detail",
    key: "order-itinerary-detail",
    route: "/order-itinerary/:id",
    component: <OrderItineraryDetail />,
    hideInSidenav: true,
  },
  {
    type: "route",
    name: "Merchant Order Line Detail",
    key: "merchant-order-line-detail",
    route: "/merchant-order-line/:id",
    component: <MerchantOrderLineDetail />,
    hideInSidenav: true,
  },
  {
    type: "route",
    name: "Order Coupon Detail",
    key: "order-coupon-detail",
    route: "/order-coupon/:id",
    component: <OrderCouponDetail />,
    hideInSidenav: true,
  },
  {
    type: "route",
    name: "Order Comm Detail",
    key: "order-comm-detail",
    route: "/order-comm/:id",
    component: <OrderCommDetail />,
    hideInSidenav: true,
  },
  {
    type: "route",
    name: "Coupon Detail",
    key: "coupon-detail",
    route: "/coupon/:id",
    component: <CouponDetail />,
    hideInSidenav: true,
  },
  {
    type: "route",
    name: "Payment Transaction Detail",
    key: "payment-transaction-detail",
    route: "/payment-transaction/:id",
    component: <PaymentTransactionDetail />,
    hideInSidenav: true,
  },
  {
    type: "route",
    name: "Order Cancellation Detail",
    key: "order-cancellation-detail",
    route: "/order-cancellation/:id",
    component: <OrderCancellationDetail />,
    hideInSidenav: true,
  },
  {
    type: "route",
    name: "Merchant Detail",
    key: "merchant-detail",
    route: "/merchant/:id",
    component: <MerchantDetail />,
    hideInSidenav: true,
  },
  {
    type: "route",
    name: "Travel Contact Detail",
    key: "travel-contact-detail",
    route: "/travel-contact/:id",
    component: <TravelContactDetail />,
    hideInSidenav: true,
  },
  {
    type: "route",
    name: "Opportunity Detail",
    key: "opportunity-detail",
    route: "/opportunity/:id",
    component: <OpportunityDetail />,
    hideInSidenav: true,
  },
  {
    type: "route",
    name: "Customer Detail",
    key: "customer-detail",
    route: "/customer/:id",
    component: <CustomerDetail />,
    hideInSidenav: true,
  },
  {
    type: "route",
    name: "Pricing Category Detail",
    key: "pricing-category-detail",
    route: "/pricing-category/:id",
    component: <PricingCategoryDetail />,
    hideInSidenav: true,
  },
  {
    type: "route",
    name: "Customer Coupon Detail",
    key: "customer-coupon-detail",
    route: "/customer-coupon/:id",
    component: <CustomerCouponDetail />,
    hideInSidenav: true,
  },
  {
    type: "route",
    name: "Loyalty Rule Detail",
    key: "loyalty-rule-detail",
    route: "/loyalty-rule/:id",
    component: <LoyaltyRuleDetail />,
    hideInSidenav: true,
  },
  {
    type: "route",
    name: "Loyalty Ledger Detail",
    key: "loyalty-ledger-detail",
    route: "/loyalty-ledger/:id",
    component: <LoyaltyLedgerDetail />,
    hideInSidenav: true,
  },
  {
    type: "route",
    name: "Loyalty Summary Detail",
    key: "loyalty-summary-detail",
    route: "/loyalty-summary/:id",
    component: <LoyaltySummaryDetail />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "Guide Trip Notes",
    key: "guide-trip-notes",
    icon: <Icon fontSize="small">note</Icon>,
    route: "/guide-trip-notes",
    component: <GuideTripNotes />,
    hideInSidenav: true,
  },
  {
    type: "route",
    name: "Guide Trip Note Detail",
    key: "guide-trip-note-detail",
    route: "/guide-trip-note/:id",
    component: <GuideTripNoteDetail />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "Referral Codes",
    key: "referral-codes",
    icon: <Icon fontSize="small">qr_code</Icon>,
    route: "/referral-codes",
    component: <ReferralCodes />,
    hideInSidenav: true,
  },
  {
    type: "route",
    name: "Referral Code Detail",
    key: "referral-code-detail",
    route: "/referral-code/:id",
    component: <ReferralCodeDetail />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "Travel Invoices",
    key: "travel-invoices",
    icon: <Icon fontSize="small">receipt</Icon>,
    route: "/travel-invoices",
    component: <TravelInvoices />,
    hideInSidenav: true,
  },
  {
    type: "route",
    name: "Travel Invoice Detail",
    key: "travel-invoice-detail",
    route: "/travel-invoice/:id",
    component: <TravelInvoiceDetail />,
    hideInSidenav: true,
  },
  {
    type: "collapse",
    name: "Travel Invoice Line Items",
    key: "travel-invoice-line-items",
    icon: <Icon fontSize="small">list_alt</Icon>,
    route: "/travel-invoice-line-items",
    component: <TravelInvoiceLineItems />,
    hideInSidenav: true,
  },
  {
    type: "route",
    name: "Travel Invoice Line Item Detail",
    key: "travel-invoice-line-item-detail",
    route: "/travel-invoice-line-item/:id",
    component: <TravelInvoiceLineItemDetail />,
    hideInSidenav: true,
  },
  {
    type: "route",
    name: "Create Travel Order",
    key: "travel-order-create",
    route: "/travel-orders/new",
    component: <CreateTravelOrder />,
    hideInSidenav: true,
  },
  {
    type: "route",
    name: "Public Payment",
    key: "public-pay",
    route: "/pay/:token",
    component: <PublicPayPage />,
    hideInSidenav: true,
  },
  {
    type: "route",
    name: "Merchant Allocation Respond",
    key: "merchant-allocation-respond",
    route: "/merchant-allocations/respond/:token",
    component: <MerchantAllocationRespond />,
    hideInSidenav: true,
  },
  {
    type: "route",
    name: "Merchant Order Line Respond",
    key: "merchant-order-line-respond",
    route: "/merchant-order-lines/respond/:token",
    component: <MerchantOrderLineRespond />,
    hideInSidenav: true,
  },
  {
    type: "route",
    name: "Travel Order Payment",
    key: "travel-order-payment",
    route: "/travel-orders/payment",
    component: <PaymentCheckoutPage />,
    hideInSidenav: true,
  },
  {
    type: "route",
    name: "Edit Travel Order",
    key: "travel-order-edit",
    route: "/travel-orders/:id/edit",
    component: <CreateTravelOrder />,
    hideInSidenav: true,
  },
  {
    type: "route",
    name: "Detailed Trip",
    key: "trip-detail",
    route: "/trips/detail/:tripId",
    component: <TripDetail  />,
    hideInSidenav: true,
  },
  // ------------------------------------------------------------------
  //   REAL ESTATE EDITION (RE_PROJECTS, RE_SALES, RE_BROKERAGE, RE_LEASING,
  //   RE_MORTGAGE). Keys are the registry's (module_registry.py); the
  //   sidenav shows the three groups plus Leasing and Mortgages to tenants
  //   holding the module. Detail and wizard pages are hidden (App.js).
  // ------------------------------------------------------------------
  {
    type: "collapse",
    name: "Real Estate",
    key: "real-estate",
    icon: <Icon fontSize="small">apartment</Icon>,
    collapse: [
      {
        type: "collapse",
        name: "Dashboard",
        key: "re-dashboard",
        icon: <Icon fontSize="small">space_dashboard</Icon>,
        route: "/real-estate/dashboard",
        component: <ByUi legacy={<ReDashboard />} v2={<ReHomeV2 />} />,
        hideInSidenav: false,
      },
      {
        type: "collapse",
        name: "Projects",
        key: "re-projects",
        icon: <Icon fontSize="small">location_city</Icon>,
        route: "/real-estate/projects",
        component: <ReEntityList entityKey="re-projects" />,
        hideInSidenav: false,
      },
      {
        type: "collapse",
        name: "Inventory",
        key: "re-inventory-grid",
        icon: <Icon fontSize="small">grid_view</Icon>,
        route: "/real-estate/inventory",
        component: <ReInventoryGrid />,
        hideInSidenav: false,
      },
      {
        type: "collapse",
        name: "Units",
        key: "re-units",
        icon: <Icon fontSize="small">meeting_room</Icon>,
        route: "/real-estate/units",
        component: <ReEntityList entityKey="re-units" />,
        hideInSidenav: false,
      },
      {
        type: "collapse",
        name: "Developers",
        key: "re-developers",
        icon: <Icon fontSize="small">engineering</Icon>,
        route: "/real-estate/developers",
        component: <ReEntityList entityKey="re-developers" />,
        hideInSidenav: false,
      },
      {
        type: "collapse",
        name: "Price Lists",
        key: "re-price-lists",
        icon: <Icon fontSize="small">sell</Icon>,
        route: "/real-estate/price-lists",
        component: <ReEntityList entityKey="re-price-lists" />,
        hideInSidenav: false,
      },
      {
        type: "collapse",
        name: "Amenities",
        key: "re-amenities",
        icon: <Icon fontSize="small">pool</Icon>,
        route: "/real-estate/amenities",
        component: <ReEntityList entityKey="re-amenities" />,
        hideInSidenav: false,
      },
      {
        type: "route",
        name: "Buildings",
        key: "re-buildings",
        route: "/real-estate/buildings",
        component: <ReEntityList entityKey="re-buildings" />,
        hideInSidenav: true,
      },
      {
        type: "route",
        name: "Unit Types",
        key: "re-unit-types",
        route: "/real-estate/unit-types",
        component: <ReEntityList entityKey="re-unit-types" />,
        hideInSidenav: true,
      },
      {
        type: "route",
        name: "Project Detail",
        key: "re-project-detail",
        route: "/real-estate/projects/:id",
        component: <ReProjectDetail />,
        hideInSidenav: true,
      },
      {
        type: "route",
        name: "Developer Detail",
        key: "re-developer-detail",
        route: "/real-estate/developers/:id",
        component: <ReEntityDetail entityKey="re-developers" />,
        hideInSidenav: true,
      },
      {
        type: "route",
        name: "Building Detail",
        key: "re-building-detail",
        route: "/real-estate/buildings/:id",
        component: <ReEntityDetail entityKey="re-buildings" />,
        hideInSidenav: true,
      },
      {
        type: "route",
        name: "Unit Type Detail",
        key: "re-unit-type-detail",
        route: "/real-estate/unit-types/:id",
        component: <ReEntityDetail entityKey="re-unit-types" />,
        hideInSidenav: true,
      },
      {
        type: "route",
        name: "Unit Detail",
        key: "re-unit-detail",
        route: "/real-estate/units/:id",
        component: <ReEntityDetail entityKey="re-units" />,
        hideInSidenav: true,
      },
      {
        type: "route",
        name: "Price List Detail",
        key: "re-price-list-detail",
        route: "/real-estate/price-lists/:id",
        component: <ReEntityDetail entityKey="re-price-lists" />,
        hideInSidenav: true,
      },
    ],
  },
  {
    type: "collapse",
    name: "Property Sales",
    key: "re-sales",
    icon: <Icon fontSize="small">real_estate_agent</Icon>,
    collapse: [
      {
        type: "collapse",
        name: "Viewings",
        key: "re-viewings",
        icon: <Icon fontSize="small">event</Icon>,
        route: "/real-estate/viewings",
        component: <ReViewingsCalendar />,
        hideInSidenav: false,
      },
      {
        type: "collapse",
        name: "Unit Holds",
        key: "re-unit-holds",
        icon: <Icon fontSize="small">pan_tool</Icon>,
        route: "/real-estate/unit-holds",
        component: <ReUnitHolds />,
        hideInSidenav: false,
      },
      {
        type: "collapse",
        name: "Bookings",
        key: "re-bookings",
        icon: <Icon fontSize="small">assignment_turned_in</Icon>,
        route: "/real-estate/bookings",
        component: <ReBookingsList />,
        hideInSidenav: false,
      },
      {
        type: "collapse",
        name: "Payment Plans",
        key: "re-payment-plans",
        icon: <Icon fontSize="small">payments</Icon>,
        route: "/real-estate/payment-plans",
        component: <RePaymentPlans />,
        hideInSidenav: false,
      },
      {
        type: "collapse",
        name: "Cancellations",
        key: "re-cancellations",
        icon: <Icon fontSize="small">cancel</Icon>,
        route: "/real-estate/cancellations",
        component: <ReEntityList entityKey="re-cancellations" />,
        hideInSidenav: false,
      },
      {
        type: "route",
        name: "Viewing Detail",
        key: "re-viewing-detail",
        route: "/real-estate/viewings/:id",
        component: <ReEntityDetail entityKey="re-viewing-detail" />,
        hideInSidenav: true,
      },
      {
        type: "route",
        name: "New Booking",
        key: "re-booking-new",
        route: "/real-estate/bookings/new",
        component: <ReBookingWizard />,
        hideInSidenav: true,
      },
      {
        type: "route",
        name: "Booking Detail",
        key: "re-booking-detail",
        route: "/real-estate/bookings/:id",
        component: <ReBookingDetail />,
        hideInSidenav: true,
      },
      {
        type: "route",
        name: "Payment Plan Detail",
        key: "re-payment-plan-detail",
        route: "/real-estate/payment-plans/:id",
        component: <RePaymentPlanDetail />,
        hideInSidenav: true,
      },
    ],
  },
  {
    type: "collapse",
    name: "Brokerage",
    key: "re-brokerage",
    icon: <Icon fontSize="small">handshake</Icon>,
    collapse: [
      {
        type: "collapse",
        name: "Broker Firms",
        key: "re-broker-firms",
        icon: <Icon fontSize="small">business</Icon>,
        route: "/real-estate/broker-firms",
        component: <ReEntityList entityKey="re-broker-firms" />,
        hideInSidenav: false,
      },
      {
        type: "collapse",
        name: "Agents",
        key: "re-broker-agents",
        icon: <Icon fontSize="small">badge</Icon>,
        route: "/real-estate/broker-agents",
        component: <ReEntityList entityKey="re-broker-agents" />,
        hideInSidenav: false,
      },
      {
        type: "collapse",
        name: "Listings",
        key: "re-listings",
        icon: <Icon fontSize="small">storefront</Icon>,
        route: "/real-estate/listings",
        component: <ByUi legacy={<ReEntityList entityKey="re-listings" />} v2={<ListingsV2 />} />,
        hideInSidenav: false,
      },
      {
        type: "collapse",
        name: "Commission Rules",
        key: "re-commission-rules",
        icon: <Icon fontSize="small">rule</Icon>,
        route: "/real-estate/commission-rules",
        component: <ReEntityList entityKey="re-commission-rules" />,
        hideInSidenav: false,
      },
      {
        type: "collapse",
        name: "Commissions",
        key: "re-commissions",
        icon: <Icon fontSize="small">account_balance_wallet</Icon>,
        route: "/real-estate/commissions",
        component: <ReCommissionsLedger />,
        hideInSidenav: false,
      },
      {
        type: "collapse",
        name: "Payouts",
        key: "re-commission-payouts",
        icon: <Icon fontSize="small">price_check</Icon>,
        route: "/real-estate/commission-payouts",
        component: <ReCommissionPayouts />,
        hideInSidenav: false,
      },
      {
        type: "collapse",
        name: "Margin Report",
        key: "re-margin-report",
        icon: <Icon fontSize="small">query_stats</Icon>,
        route: "/real-estate/margin-report",
        component: <ReMarginReport />,
        hideInSidenav: false,
      },
      {
        type: "route",
        name: "Broker Firm Detail",
        key: "re-broker-firm-detail",
        route: "/real-estate/broker-firms/:id",
        component: <ReEntityDetail entityKey="re-broker-firms" />,
        hideInSidenav: true,
      },
      {
        type: "route",
        name: "Agent Detail",
        key: "re-broker-agent-detail",
        route: "/real-estate/broker-agents/:id",
        component: <ReEntityDetail entityKey="re-broker-agents" />,
        hideInSidenav: true,
      },
      {
        type: "route",
        name: "Listing Detail",
        key: "re-listing-detail",
        route: "/real-estate/listings/:id",
        component: <ByUi legacy={<ReEntityDetail entityKey="re-listings" />} v2={<ListingRecordV2 />} />,
        hideInSidenav: true,
      },
      // Customer portal (RE_CUSTOMER_PORTAL): applications sent from the
      // agency's website. v2 only; the classic sidenav leaves it out.
      {
        type: "collapse",
        name: "Applications",
        key: "re-applications",
        icon: <Icon fontSize="small">assignment_ind</Icon>,
        route: "/real-estate/applications",
        component: <ByUi legacy={<ReApplicationsClassicNotice />} v2={<ApplicationsV2 />} />,
        hideInSidenav: false,
        v2Only: true,
      },
      {
        type: "route",
        name: "Application Detail",
        key: "re-application-detail",
        route: "/real-estate/applications/:id",
        component: <ByUi legacy={<ReApplicationsClassicNotice />} v2={<ApplicationRecordV2 />} />,
        hideInSidenav: true,
      },
    ],
  },
  {
    type: "collapse",
    name: "Leasing",
    key: "re-leasing",
    icon: <Icon fontSize="small">key</Icon>,
    collapse: [
      {
        type: "collapse",
        name: "Leases",
        key: "re-leases",
        icon: <Icon fontSize="small">description</Icon>,
        route: "/real-estate/leases",
        component: <ReLeasesList />,
        hideInSidenav: false,
      },
      {
        type: "collapse",
        name: "Rent Schedule",
        key: "re-rent-schedule",
        icon: <Icon fontSize="small">event_repeat</Icon>,
        route: "/real-estate/rent-schedule",
        component: <ReRentSchedule />,
        hideInSidenav: false,
      },
      {
        type: "route",
        name: "Lease Detail",
        key: "re-lease-detail",
        route: "/real-estate/leases/:id",
        component: <ReLeaseDetail />,
        hideInSidenav: true,
      },
    ],
  },
  {
    type: "collapse",
    name: "Mortgages",
    key: "re-mortgages",
    icon: <Icon fontSize="small">account_balance</Icon>,
    collapse: [
      {
        type: "collapse",
        name: "Applications",
        key: "re-mortgage-applications",
        icon: <Icon fontSize="small">view_kanban</Icon>,
        route: "/real-estate/mortgage-applications",
        component: <ReMortgagePipeline />,
        hideInSidenav: false,
      },
      {
        type: "collapse",
        name: "Lenders",
        key: "re-lenders",
        icon: <Icon fontSize="small">corporate_fare</Icon>,
        route: "/real-estate/lenders",
        component: <ReEntityList entityKey="re-lenders" />,
        hideInSidenav: false,
      },
      {
        type: "route",
        name: "Mortgage Application Detail",
        key: "re-mortgage-application-detail",
        route: "/real-estate/mortgage-applications/:id",
        component: <ReMortgageApplicationDetail />,
        hideInSidenav: true,
      },
    ],
  },
];

export default routes;
